var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-bi",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M60.84 337h175v175h-175z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fillRule: "evenodd",
    transform: "translate(-178 -985.97) scale(2.9257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 337l146.56 87.5L0 512zm293.12 0l-146.56 87.5L293.12 512z",
    fill: "#00cf00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 337l146.56 87.5L293.12 337zm0 175l146.56-87.5L293.12 512z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.12 337h-27.31L0 495.7v16.305h27.31l265.81-158.7z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.168 424.496c0 27.948-22.656 50.604-50.604 50.604S95.96 452.444 95.96 424.496s22.656-50.604 50.604-50.604 50.604 22.656 50.604 50.604z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 337v16.305l265.81 158.7h27.31V495.7L27.31 337z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00de00",
    strokeWidth: "1pt",
    fill: "red",
    d: "M156.523 405.41l-6.58.11-3.4 5.62-3.39-5.63-6.57-.14 3.18-5.75-3.16-5.768 6.57-.113 3.41-5.626 3.39 5.638 6.57.14-3.19 5.748zm-22.043 38.16l-6.58.11-3.4 5.62-3.39-5.63-6.57-.14 3.18-5.75-3.16-5.768 6.57-.113 3.41-5.626 3.39 5.638 6.57.14-3.19 5.748zm44.627 0l-6.58.11-3.4 5.62-3.39-5.63-6.57-.14 3.18-5.75-3.16-5.768 6.57-.113 3.41-5.626 3.39 5.638 6.57.14-3.19 5.748z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBi);
export default __webpack_public_path__ + "static/media/bi.aa8e3ffc467fc5cdf9cccdbe286c5606.svg";
export { ForwardRef as ReactComponent };